module.exports = __webpack_public_path__ + "img/contact-us.571efac3.gif";